// Registers the offline-capable service worker (public/sw.js) in production
// only, so development never serves stale files. After it is ready, the page
// tells the worker which same-origin files it already loaded so they are saved
// for offline use immediately, not only on the second visit.
export function register({ production = process.env.NODE_ENV === 'production' } = {}) {
    if (!production || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

    const start = async () => {
        try {
            await navigator.serviceWorker.register('/sw.js');
            const registration = await navigator.serviceWorker.ready;
            const entries = typeof performance.getEntriesByType === 'function'
                ? performance.getEntriesByType('resource')
                : [];
            const urls = entries
                .map((entry) => entry.name)
                .filter((name) => name.startsWith(window.location.origin));
            if (registration.active) registration.active.postMessage({ type: 'CACHE_URLS', urls });
        } catch (e) {
            // Offline support is a bonus: the site works fine without it.
        }
    };

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
}
